export default function GripHandle({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 8 14"
      width="8"
      height="14"
      className={className}
      aria-hidden="true"
    >
      {[0, 4, 8].map((y) =>
        [0, 4].map((x) => (
          <circle key={`${x}-${y}`} cx={x + 2} cy={y + 2} r="1.25" />
        )),
      )}
    </svg>
  );
}
